import { type FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { mdiArrowULeftTop } from "@mdi/js";
import { Box } from "@mui/material";

export type AssignmentViewActionsProps = {
  onCancel?: () => void;
  onUndo?: () => void;
  onConfirm?: () => void;
  stagedCount?: number;
  disabled?: boolean;
};

export const AssignmentViewActions: FC<AssignmentViewActionsProps> = ({
  onCancel,
  onUndo,
  onConfirm,
  stagedCount = 0,
  disabled = false,
}) => {
  const { classes } = useStyles();
  const confirmButtonTitle =
    stagedCount > 0 ? `Confirm (${stagedCount})` : "Confirm";

  return (
    <Box className={classes.actions}>
      <MiButton
        className={classes.cancelButton}
        title="Cancel"
        variant={BUTTON_VARIANTS.TEXT}
        color={BUTTON_COLORS.BLACK}
        disabled={disabled}
        onClick={onCancel}
      />
      <MiButton
        title="Undo"
        variant={BUTTON_VARIANTS.OUTLINED}
        startIcon={{ path: mdiArrowULeftTop }}
        disabled={disabled}
        onClick={onUndo}
      />
      <MiButton
        title={confirmButtonTitle}
        variant={BUTTON_VARIANTS.CONTAINED}
        disabled={disabled}
        onClick={onConfirm}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  cancelButton: {
    textDecoration: "underline",
  },
  root: {
    padding: theme.spacing(1.5, 2),
    width: "100%",
    boxSizing: "border-box",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));
